import React from "react";
import GridContainer from "common/components/Grid/GridContainer.jsx";
import GridItem from "common/components/Grid/GridItem.jsx";
import loadContent from "core-module/hoc/loadContent";
import * as api from "core-module/services/api";

import LoadingBox from "common/components/LoadingBox";

import PhoneByBillingpackage from "./PhoneByBillingpackage.jsx";
import BillingPackageSelectCard from "./BillingPackageSelectCard.jsx";
import NoPhoneAccount from "./NoPhoneAccount.jsx";

import LongDistanceBalanceWizard from "./InternationalAllowanceBalanceWizard.jsx";

import { showAlert } from "../../core-module/services/errorAlert/reducers";
import store from "../../store";

class Phone extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedBillingPackage: 0,
      selectedEmergencyProfile: 0,
      voipBpsId: 0,
      associatedDnList: [],
      wizard: null,
      loading: false,
    };

    this.billingpackageList = this.props.getList((oGet, id) => id);
    this.emergencyprofileType = {};
    this.props.getList((oGet, id) => {
      this.emergencyprofileType[id] = oGet("emergencyprofile_type");
    });
  }

  //Wizard/Screen Rendering control

  handleSelectBillingPackage = (event) => {
    this.setState({ selectedBillingPackage: event.target.value });
  };

  closeWizard = () => this.setState({ wizard: null });

  selectLongDistanceBalanceWizard = () => {
    this.setState({
      wizard: "longdistancebalance",
    });
  };

  onFinishLongDistanceBalanceWizard = async (ids, payload) => {
    this.setState({ loading: true });

    let endpoint = `user.${ids.user}/billingpackage.${ids.billingpackage}/voipldadd`;

    const postNLoadResponse = await api.postNload(
      endpoint,
      payload,
      0,
      `user.${ids.user}/billingpackage.${ids.billingpackage}/voipldbalance`,
      `user.${ids.user}/billingpackage.${ids.billingpackage}/voipldhistory`
    );

    if (postNLoadResponse.success) {
      this.setState({ wizard: null, loading: false });
    } else {
      store.dispatch(showAlert(postNLoadResponse.message));
      this.setState({ wizard: null, loading: false });
    }
  };

  render() {
    if (this.state.loading) {
      return <LoadingBox />;
    }

    if (
      this.billingpackageList == null ||
      this.billingpackageList.length === 0
    ) {
      return (
        <GridContainer justify="center">
          <GridItem key="noVoip" xs={12}>
            <NoPhoneAccount />
          </GridItem>
        </GridContainer>
      );
    }

    const bpid = this.billingpackageList[this.state.selectedBillingPackage];

    if (this.state.wizard === "longdistancebalance") {
      return (
        <div>
          <LongDistanceBalanceWizard
            onFinishLongDistanceBalanceWizard={
              this.onFinishLongDistanceBalanceWizard
            }
            closeWizard={this.closeWizard}
            pathids={{
              billingpackage: bpid,
              voipldhistory: 0,
            }}
          />
        </div>
      );
    }

    return (
      <GridContainer justify="center">
        {this.billingpackageList.length === 1 ? null : (
          <GridItem key="selectbpid" xs={12}>
            <BillingPackageSelectCard
              selectedBillingPackage={this.state.selectedBillingPackage}
              handleSelect={this.handleSelectBillingPackage}
              billingpackageList={this.billingpackageList}
            />
          </GridItem>
        )}
        <GridItem xs={12}>
          <PhoneByBillingpackage
            pathids={{
              billingpackage: bpid,
            }}
            onClickLongDistanceBalanceAdd={this.selectLongDistanceBalanceWizard}
            shouldRender="InternationalAllowance"
          />
        </GridItem>
      </GridContainer>
    );
  }
}

export default loadContent("user.session/billingpackage_voip", Phone);
